module.exports = __webpack_public_path__ + "static/img/logo-10.32f6a2a0.png";